import React from 'react';
import { I18n } from 'common/i18n';
export interface BackButtonProps {
  onClick: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  return (
    <button className="btn btn-default btn-sm close-modal back-button" onClick={onClick}>
      <span className="socrata-icon-arrow-prev"></span>
      {` ${I18n.t('common.action_buttons.back')}`}
    </button>
  );
};

export default BackButton;
